import { render, staticRenderFns } from "./RenunciaInicio.html?vue&type=template&id=57aa7adc&external"
import script from "./RenunciaInicio.vue?vue&type=script&lang=js"
export * from "./RenunciaInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports